var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{staticClass:"w-full",attrs:{"label":"name","options":_vm.companies},model:{value:(_vm.current),callback:function ($$v) {_vm.current=$$v},expression:"current"}})}
var staticRenderFns = []

export { render, staticRenderFns }